import { handleActions } from "redux-actions";
import initialState from "./app.state";
import { SET_ERROR } from "./app.action";

const AppReducer = handleActions(
    {
        APP_ACTION: (state, action) => ({ ...state }),
        [SET_ERROR]: (state, { payload }) => ({
            ...state,
            error: {
                message: payload?.message || "",
                status: payload?.status || "",
            },
        }),
    },
    initialState
);

export default AppReducer;
